import styled from 'styled-components';

export const StyledTagRounded = styled.span`
  .tag-rounded {
    display: inline-flex;
    text-transform: uppercase;
    padding: 4px 12px;
    border-radius: 50px;
    border: 1px solid ${({ theme }) => theme.colors.getTransparentColor(theme.colors.mainOrange, 0.3)};
    background: ${({ theme }) => theme.colors.getTransparentColor(theme.colors.mainOrange, 0.06)};
    width: min-content;
    white-space: nowrap;
    cursor: pointer;
    transition: all ease 0.4s;

    &:hover {
      background: ${({ theme }) => theme.colors.getTransparentColor(theme.colors.mainOrange, 0.12)};
      border-color: ${({ theme }) => theme.colors.mainOrange};
    }
  }
`;
